import { useMutation } from '@tanstack/react-query';
import { bulkDeleteBankOperation } from 'config/requests/bankOperations';
import { queryClient } from 'providers/queryClient';

export function useBulkDeleteRequestsBankOps() {
  const mutation = useMutation({
    mutationFn: ({ ids }: { ids: number[] }) => bulkDeleteBankOperation(ids),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['bank_operations/pending_statuses'] });
    },
  });

  return { bulkDeleteRequestsBankOps: mutation };
}
